// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"move-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18.5 15L21.5 12L18.5 9M5.5 8.99999L2.5 12L5.5 15M15 5.5L12 2.5L9 5.5M9 18.5L12 21.5L15 18.5M12 3.75V12M12 12V20.25M12 12L20.25 12M12 12L3.75 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Move1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'move-1',
    ref,
    icon: element,
  },
));

Move1Icon.displayName = 'Move1Icon';

export default Move1Icon;
